import Vue from 'vue';
import VueTheMask from 'vue-the-mask';
import { Settings } from '@compassdigital/foodworks.api.ts';

import conf from '@/conf';
import { registerDisabledUserRedirect } from '@/util/AuthUtil';
import initApiInterceptors from './plugins/api-interceptor';

import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import './styles/zeplin-fonts.css';
import './plugins/class-component-hooks';
import './plugins/chartjs';

Settings.configuration.basePath = conf.basePath;

registerDisabledUserRedirect(() => {
  if (router.currentRoute.path !== '/login') {
    router.push('/login');
  }
});

initApiInterceptors();

Vue.use(VueTheMask);
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
}).$mount('#app');
